import {
  ROTATION_RELEASE_SETTING,
  SETTINGS_PACKAGE,
  STAY_AWAKE_RELEASE_SETTING,
} from '@mxa-argos/modules/forja/constants/forja.constants';
import type { ForjaStep } from '@mxa-argos/modules/forja/interfaces/forja-step.interface';
import { settingsStep } from '@mxa-argos/modules/forja/lib/provisioning/steps/phase-a.steps';

export function releaseSteps(): ForjaStep[] {
  // The operator walks Settings into Developer Options to enable USB debugging, and the app stays
  // parked there; force-stopping it makes the next launch start at the root menu. Only
  // ActivityRecord lines count: the dump also names the package in the kiosk allowlist and in
  // stale window-manager fields that survive the force-stop.
  const settingsAppClosed: ForjaStep = {
    name: 'settings app closed',
    verify: async (device) => {
      const output = await device.shell('dumpsys', 'activity', 'activities');
      return !output
        .split('\n')
        .some((line) => line.includes('ActivityRecord{') && line.includes(`${SETTINGS_PACKAGE}/`));
    },
    apply: async (device) => {
      await device.shell('am', 'force-stop', SETTINGS_PACKAGE);
    },
    verifyTimeoutMs: 5_000,
  };

  return [
    settingsStep(...STAY_AWAKE_RELEASE_SETTING),
    settingsStep(...ROTATION_RELEASE_SETTING),
    settingsAppClosed,
  ];
}
